import { gql } from '@apollo/client';

export const getUserRitualsQuery = gql`
    query GetUserRituals {
        user {
            id
            morningRitualId
            eveningRitualId
        }
    }
`;
